import React from 'react';

function TermsOfService() {
  return (
    <div>
      <div className="header user-header">
        <div className="container">
          <h1>Terms of Service</h1>
        </div>
      </div>

      <div className="container">
        <div className="content-page">
          <p><em>Last Updated: December 31, 2025</em></p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Coupon Adda, you accept and agree to be bound by the terms and conditions
              of this agreement. If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section>
            <h2>2. Use of Service</h2>
            <p>
              Coupon Adda provides a platform for discovering coupons and deals. You agree to use the service
              only for lawful purposes and in accordance with these terms.
            </p>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any fraudulent or unlawful purpose</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Interfere with or disrupt the service or servers</li>
              <li>Attempt to gain unauthorized access to any part of the service</li>
              <li>Use automated systems to scrape or collect data from the service</li>
            </ul>
          </section>

          <section>
            <h2>3. Coupon Validity and Accuracy</h2>
            <p>
              While we strive to provide accurate and up-to-date information, we do not guarantee the validity,
              accuracy, or availability of any coupon or deal. Coupons are subject to merchant terms and conditions
              and may expire or change without notice.
            </p>
          </section>

          <section>
            <h2>4. Third-Party Merchants</h2>
            <p>
              When you click on a coupon or deal, you may be redirected to third-party merchant websites.
              We are not responsible for:
            </p>
            <ul>
              <li>The content, products, or services of third-party merchants</li>
              <li>Any transactions between you and third-party merchants</li>
              <li>The privacy practices of third-party websites</li>
              <li>Any disputes arising from your use of third-party services</li>
            </ul>
          </section>

          <section>
            <h2>5. Intellectual Property</h2>
            <p>
              The content, design, graphics, and other materials on Coupon Adda are protected by copyright
              and other intellectual property laws. You may not copy, modify, distribute, or reproduce any
              content without our prior written permission.
            </p>
          </section>

          <section>
            <h2>6. Disclaimer of Warranties</h2>
            <p>
              Coupon Adda is provided "as is" without warranties of any kind, either express or implied.
              We do not warrant that the service will be uninterrupted, secure, or error-free.
            </p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Coupon Adda shall not be liable for any indirect,
              incidental, special, or consequential damages arising out of or in connection with your use
              of the service.
            </p>
          </section>

          <section>
            <h2>8. User Submissions</h2>
            <p>
              If you submit content to us (such as feedback or suggestions), you grant us a non-exclusive,
              royalty-free, perpetual, and worldwide license to use, modify, and distribute that content.
            </p>
          </section>

          <section>
            <h2>9. Modifications to Service</h2>
            <p>
              We reserve the right to modify, suspend, or discontinue any part of the service at any time
              without notice or liability.
            </p>
          </section>

          <section>
            <h2>10. Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. Continued use of the service after
              changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>11. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of India.
              Any disputes shall be subject to the exclusive jurisdiction of the courts in [Your City].
            </p>
          </section>

          <section>
            <h2>12. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us at:
              <br />
              Email: support@couponaadda.in
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
